import Button from '@pelckmans/elementis/components/button';
import Dialog from '@pelckmans/elementis/components/dialog';
import Skeleton from '@pelckmans/elementis/components/skeleton';
import Plus from '@pelckmans/elementis/icons/plus';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../../contexts/ModalContext';
import AddLicenseModal from '../../../shared-components/AddLicenseModal';

type Props = {
  isLoading: boolean;
  onRefetch: () => void;
  'aria-label': string;
};

const BASE = 'PAGES.MY_METHODS.EMPTY_STATE.DIALOG';

function Message({ onRefetch }: { onRefetch: () => void }) {
  const { t } = useTranslation();
  const { showModal } = useContext(ModalContext);
  return (
    <div className="no-license-dialog">
      <Dialog size="sm" aria-label={t(`${BASE}.A11Y_LABEL`)} id="empty-state-dialog">
        <Dialog.Header title={t(`${BASE}.TITLE`)} />
        <Dialog.Body>{t(`${BASE}.MESSAGE`)}</Dialog.Body>
        <Dialog.Footer
          buttonGroupPropsRight={{
            role: undefined,
            'aria-label': undefined,
            children: (
              <Button
                prominence="secondary"
                startIcon={<Plus />}
                onClick={() => showModal(<AddLicenseModal id="add-license-modal" onRefetch={onRefetch} />)}
              >
                {t(`${BASE}.BUTTON.LABEL`)}
              </Button>
            ),
          }}
        />
      </Dialog>
    </div>
  );
}

function EmptyState({ isLoading, onRefetch, 'aria-label': ariaLabel }: Props) {
  useEffect(() => {
    // Scroll container is the main element in the page layout
    const mainElement = document.querySelector('main');
    if (!mainElement) return;
    mainElement.style.overflow = 'hidden';

    return () => {
      mainElement.style.overflow = '';
    };
  }, []);

  return (
    <>
      {!isLoading && <Message onRefetch={onRefetch} />}
      <Skeleton animate={isLoading} className="skeleton-methods" aria-label={ariaLabel}>
        {Object.keys(Array.from({ length: 40 })).map(i => (
          <Skeleton.Bone height={296} key={i} />
        ))}
      </Skeleton>
    </>
  );
}

export default EmptyState;
